import React, { useState, useEffect } from "react";
import { fetchData, imageBaseURL } from "../../../utils/fetchData";
import { JNTUK_API_Urls } from "../../../utils/api.config";

const SearchModal = () => {
  const [data, setData] = useState([]);
  const [searchField, setSearchField] = useState("");
  useEffect(() => {
    fetchData(
      JNTUK_API_Urls["Site-Map"] + `?filters[Title][$containsi]=${searchField}`,
      setData
    );
  }, [searchField]);
  const searchModalRemove = () => {
    document.body.classList.remove("modal-open", "overflow-hidden");
  };

  const handleChange = (e) => {
    setSearchField(e.target.value);
  };

  return (
    <React.Fragment>
      <div className="search-modal">
        <div
          className="h-100 w-100 position-fixed"
          onClick={searchModalRemove}
        ></div>
        <div
          className="h-100 w-100 position-fixed"
          onClick={searchModalRemove}
        ></div>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="search-block clearfix">
              <form>
                <div className="form-group">
                  <input
                    className="form-control"
                    placeholder="Search Here..."
                    type="text"
                    onChange={handleChange}
                  />
                </div>
              </form>
              <div className="search-results-lists">
                <ul>
                  {searchField &&
                    data?.data?.map(({ attributes }) => (
                      <li key={attributes?.Title} className="list-item">
                        <a
                          href={`${process.env.REACT_APP_JNTUK_BASE_URL}${attributes?.Path}`}
                        >
                          <div className="result-title">
                            {attributes?.Title}
                          </div>
                          <div className="result-description">
                            {attributes?.Description || ""}
                          </div>
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchModal;
